import { create } from "zustand"
import { createJSONStorage, devtools, persist } from "zustand/middleware"
import { useMedicalRecordSharedWithMeChangedSubscription$data } from "@/modules/patients/services/__generated__/useMedicalRecordSharedWithMeChangedSubscription.graphql"

type SharedMedicalRecordEvent = useMedicalRecordSharedWithMeChangedSubscription$data["medicalRecordSharedWithMeChanged"]

const SHARED_MEDICAL_RECORD_EVENTS_STORE_NAME = "sharedMedicalRecordEventsStore"

interface ISharedMedicalRecordEventsStore {
  sharedMedicalRecordEventsByPatientId: Record<string, SharedMedicalRecordEvent>
}

interface SharedMedicalRecordEventsStoreActions {
  registerSharedMedicalRecordEvent: (sharedMedicalRecordEvent: SharedMedicalRecordEvent) => void
  removeSharedMedicalRecordEvent: (patientId: string) => void
  clearStore: VoidFunction
}

const initialState: ISharedMedicalRecordEventsStore = {
  sharedMedicalRecordEventsByPatientId: {},
}

const useSharedMedicalRecordEventsStore = create<
  ISharedMedicalRecordEventsStore & SharedMedicalRecordEventsStoreActions
>()(
  devtools(
    persist(
      (set, get) => ({
        ...initialState,
        registerSharedMedicalRecordEvent: (sharedMedicalRecordEvent) =>
          set({
            sharedMedicalRecordEventsByPatientId: {
              ...get().sharedMedicalRecordEventsByPatientId,
              [sharedMedicalRecordEvent.patient.id]: sharedMedicalRecordEvent,
            },
          }),
        removeSharedMedicalRecordEvent: (patientId) => {
          const remainingSharedMedicalRecordEvents = { ...get().sharedMedicalRecordEventsByPatientId }
          delete remainingSharedMedicalRecordEvents[patientId]
          set({ sharedMedicalRecordEventsByPatientId: remainingSharedMedicalRecordEvents })
        },
        clearStore: () => set(initialState),
      }),
      {
        name: SHARED_MEDICAL_RECORD_EVENTS_STORE_NAME,
        storage: createJSONStorage(() => localStorage),
        partialize: (state) => ({ sharedMedicalRecordEventsByPatientId: state.sharedMedicalRecordEventsByPatientId }),
      },
    ),
  ),
)

export { SHARED_MEDICAL_RECORD_EVENTS_STORE_NAME, type SharedMedicalRecordEvent, useSharedMedicalRecordEventsStore }
